import React from 'react';

import svg from './assets/icons-16-arrow-forward.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconArrowForward = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-arrow-forward" />
);
